import store from "@/state/store"

export default [
  {
    path: '/',
    name: 'fila',
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (routeTo.query.chave && routeTo.query.idEmpresa) {
          next()
        } else {
          if (store.getters['auth/isTotem']) {
            next({ name: 'gerar-senha' })
          } else if (store.getters['auth/isTelevisao']) {
            next({ name: 'tv' })
          } else if (store.getters['auth/isAdmin'] || store.getters['auth/isSupervisor'] || store.getters['auth/isGerente']) {
            next({ name: 'painel-controle' })
          } else if (store.getters['auth/isAtendente']) {
            next({ name: 'atendimento' })
          } else {
            next({ name: 'cadastro-empresa' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "fila" */ './views/totem/fila'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ './views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/authenticated']) {
          // Redirect to the home page instead
          next('/')
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/minhas-senhas',
    name: 'minhas-senhas',
    pageTitle:"Minhas Senhas",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (routeTo.query.chave && routeTo.query.idEmpresa) {
          next()
        } else {
          next('404')
        }
      },
    },
    component: () => import(/* webpackChunkName: "minhas-senhas" */ './views/totem/minhas-senhas'),
  },
  {
    path: '/multi-atendimento',
    name: 'multi-atendimento',
    pageTitle: 'Multi Atendimento',
    meta: {
      authRequired: false,
      //permissions: [],
    },
    component: () => import(/* webpackChunkName: "multi-atendimento" */ './views/totem/multi-atendimento/multi-atendimento'),
  },
  {
    path: '/painel-controle',
    name: 'painel-controle',
    pageTitle: 'Painel de Controle',
    meta: {
      authRequired: true,
      permissions: ['ADMIN', 'GERENTE', 'SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "painel-controle" */ './views/totem/painel-controle/painel-controle'),
  },
  {
    path: '/painel-controle/dados-estatisticos',
    name: 'dados-estatisticos',
    pageTitle: 'Dados Estatísticos',
    meta: {
      authRequired: true,
      permissions: ['ADMIN', 'GERENTE', 'SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "dados-estatisticos" */ './views/totem/painel-controle/dados-estatisticos'),
  },
  {
    path: '/painel-controle/work-line',
    name: 'work-line',
    pageTitle: 'Work Line',
    meta: {
      authRequired: true,
      permissions: ['ADMIN', 'GERENTE', 'SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "work-line" */ './views/totem/painel-controle/work-line'),
  },
  {
    path: '/painel-controle/tat',
    name: 'tat',
    pageTitle: 'TAT',
    meta: {
      authRequired: true,
      permissions: ['ADMIN', 'GERENTE', 'SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "tat" */ './views/totem/painel-controle/tat'),
  },
  {
    path: '/painel-controle/benchmark',
    name: 'benchmark',
    pageTitle: 'Benchmark',
    meta: {
      authRequired: true,
      permissions: ['ADMIN', 'GERENTE', 'SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "benchmark" */ './views/totem/painel-controle/benchmark'),
  },
  {
    path: '/cadastro-empresa',
    name: 'cadastro-empresa',
    pageTitle:'Cadastro de Empresa',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "cadastro-empresa" */ './views/totem/cadastro-empresa/cadastro-empresa'),
  },
  {
    path: '/totem-virtual',
    name: 'totem-virtual',
    pageTitle: 'Totem Virtual',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "totem-virtual" */ './views/totem/totem-virtual/totem-virtual'),
  },
  {
    path: '/gerar-senha',
    name: 'gerar-senha',
    pageTitle:'Gerar Senha',
    meta: {
      authRequired: true,
      permissions: ['TOTEM', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "gerar-senha" */ './views/totem/gerar-senha'),
  },
  {
    path: '/qr-code',
    name: 'qr-code',
    pageTitle:'QR Code',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "qr-code" */ './views/totem/qr-code'),
  },
  {
    path: '/atendimento',
    name: 'atendimento',
    pageTitle: 'Atendimento',
    meta: {
      authRequired: true,
      permissions: ['COLABORADOR', 'SUPERVISOR', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "atendimento" */ './views/totem/atendimento/atendimento'),
  },
  {
    path: '/tv',
    name: 'tv',
    pageTitle: 'TV',
    meta: {
      authRequired: true,
      permissions: ['TELEVISAO', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "tv" */ './views/totem/tv/tv'),
  },
  {
    path: '/cadastro-usuario',
    name: 'cadastro-usuario',
    pageTitle: 'Cadstro de Usuários',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "cadastro-usuario" */ './views/totem/usuario/cadastro-usuario'),
  },
  {
    path: '/cadastro-perfil',
    name: 'cadastro-perfil',
    pageTitle: 'Cadastro de Perfil',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "cadastro-perfil" */ './views/totem/usuario/cadastro-perfil'),
  },
  {
    path: '/configuracao-impressora',
    name: 'configuracao-impressora',
    pageTitle: 'Configuração de Impressora',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import(/* webpackChunkName: "configuracao-impressora" */ './views/totem/configuracao-impressora'),
  },
  {
    path: '/cadastro-ajuda',
    name: 'cadastro-ajuda',
    pageTitle:'Ajuda',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN'],
    },
    component: () => import('./views/totem/ajuda/cadastro-ajuda'),
  },
  {
    path: '/reset-senha',
    name: 'reset-senha',
    pageTitle: 'Reset de Senha',
    meta: {
      authRequired: true,
      permissions: ['GERENTE', 'ADMIN', 'COLABORADOR','SUPERVISOR'],
    },
    component: () => import(/* webpackChunkName: "reset-senha" */ './views/totem/usuario/reset-senha'),
  },
  {
    path: '/404',
    name: '404',
    component: require(/* webpackChunkName: "404" */ './views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  }
]
